import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
	standalone: false,
	selector: 'toggle-switch',
	template: `
		<label class="switch">
			<input type="checkbox" [(ngModel)]="value" (ngModelChange)="validateAndEmitValue()" />
			<span class="slider round"></span>
		</label>
	`,
})
export class ToggleSwitchComponent {
	@Input('value') value: boolean;
	@Output() onChange = new EventEmitter();

	constructor() {}
	ngOnInit() {}

	validateAndEmitValue() {
		if (typeof this.onChange !== 'undefined') {
			window.setTimeout(() => {
				this.onChange.emit(this.value);
			}, 10);
		}
	}
}
